import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../../lib/api";
import AdminNav from "../../components/AdminNav";
import { Buildings } from "@phosphor-icons/react";

export default function Clients() {
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    api.get("/admin/clients")
      .then((r) => setClients(r.data))
      .catch((e) => setError(e.displayMessage || "Failed to load clients"))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="max-w-[1600px] mx-auto p-6" data-testid="clients-page">
      <div className="flex items-baseline justify-between mb-6">
        <div>
          <div className="overline">CONTROL TOWER</div>
          <h1 className="heading text-3xl">Clients</h1>
        </div>
        <AdminNav />
      </div>

      <div className="grid-card grid-card-strong">
        {loading ? (
          <div className="p-10 mono text-sm" data-testid="clients-loading">Loading clients…</div>
        ) : error ? (
          <div className="p-10 text-center text-sm text-[hsl(var(--danger))]" data-testid="clients-error">{error}</div>
        ) : clients.length === 0 ? (
          <div className="p-10 text-center" data-testid="clients-empty">
            <Buildings size={32} weight="duotone" className="mx-auto mb-3 opacity-50" />
            <div className="overline mb-1">NO CLIENTS</div>
            <p className="text-sm text-[hsl(var(--muted))]">No companies have been onboarded yet.</p>
          </div>
        ) : (
          <table className="table-air12">
            <thead>
              <tr>
                <th>Company</th>
                <th>Company ID</th>
                <th>Status</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {clients.map((c) => (
                <tr key={c.id} data-testid={`client-row-${c.public_company_id}`}>
                  <td>
                    <Link to={`/admin/clients/${c.id}`} className="font-semibold underline" data-testid={`client-name-${c.public_company_id}`}>
                      {c.legal_name}
                    </Link>
                  </td>
                  <td><span className="id-chip">{c.public_company_id}</span></td>
                  <td>
                    <span
                      className={`text-[10px] font-bold px-1.5 py-0.5 rounded ${c.status === "ACTIVE" ? "bg-[hsl(var(--success)/0.12)] text-[hsl(var(--success))]" : "bg-[hsl(var(--muted)/0.15)] text-[hsl(var(--muted))]"}`}
                      data-testid={`client-status-${c.public_company_id}`}
                    >
                      {c.status}
                    </span>
                  </td>
                  <td>
                    <Link to={`/admin/clients/${c.id}`} className="text-xs underline font-semibold" data-testid={`client-open-${c.public_company_id}`}>
                      View shipments →
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
